import { useCreate } from "../../hooks/useCreate";

export const CreatePermissionIndex = async (module_id, payload) => {
  try {
    return await useCreate(
      `${process.env.REACT_APP_API_URL}/permissions/index/${module_id}`,
      payload
    );
  } catch (err) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
